type MetabaseKind = "card" | "dashboard";

export type SavedResource = {
  kind: MetabaseKind;
  metabase_id: number;
  can_edit_saved?: boolean;
};

function resourceKey(kind: MetabaseKind, id: number) {
  return `${kind}:${id}`;
}

export function editableSavedResourceKeys(items: SavedResource[]) {
  return new Set(items
    .filter(item => item.can_edit_saved !== false && Number.isInteger(item.metabase_id))
    .map(item => resourceKey(item.kind, item.metabase_id)));
}

export function canEditMenuResource(
  kind: unknown,
  id: unknown,
  isCompanyAdministrator: boolean,
  editableSavedResources: ReadonlySet<string>,
) {
  if (typeof id !== "number" || !Number.isInteger(id)) return false;
  const savedKind = kind === "dashboard" ? "dashboard"
    : kind === "card" || kind === "question" || kind === "report" ? "card"
    : null;
  if (!savedKind) return false;
  return isCompanyAdministrator || editableSavedResources.has(resourceKey(savedKind, id));
}
